//#region src/components/_overlay/inert.ts
/** Elements this module made inert, so it only ever removes its own. */
var inerted = [];
/**
* Never made inert: live regions must still announce while a modal is open, and so must
* the toast region (which holds its own).
*/
var EXEMPT = "script, style, template, [aria-live], [role=\"status\"], [role=\"alert\"], [data-ds-toast-region]";
/**
* Makes everything outside the topmost modal layer inert, except the layers above it
* (a popover opened from the modal). Recomputed from scratch each time the stack changes.
*/
function syncInert(layers) {
	for (const element of inerted) element.removeAttribute("inert");
	inerted = [];
	const topModal = layers.findLastIndex((layer) => layer.modal);
	if (topModal === -1) return;
	const keep = layers.slice(topModal).map((layer) => layer.root);
	const onPath = (element) => keep.some((root) => element.contains(root));
	const walk = (parent) => {
		for (const child of Array.from(parent.children)) {
			if (keep.some((root) => root === child)) continue;
			if (onPath(child)) walk(child);
			else if (!child.hasAttribute("inert") && !child.matches(EXEMPT)) {
				child.setAttribute("inert", "");
				inerted.push(child);
			}
		}
	};
	walk(document.body);
}
//#endregion
export { syncInert };

//# sourceMappingURL=inert.js.map